var map = {
  "./desktop/index.js": [
    "94106",
    9,
    "9598",
    "76225",
    "62815",
    "33580",
    "47387",
    "3199",
    "88565",
    "50437",
    "27174",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "26088",
    "21475",
    "23842",
    "12481",
    "68519",
    "89318",
    "70171"
  ],
  "./desktop/index": [
    "94106",
    9,
    "9598",
    "76225",
    "62815",
    "33580",
    "47387",
    "3199",
    "88565",
    "50437",
    "27174",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "26088",
    "21475",
    "23842",
    "12481",
    "68519",
    "89318",
    "70171"
  ],
  "./desktop/CoronaVirus.scss": [
    "87341",
    7,
    "54008"
  ],
  "./mobile/CoronaVirus.js": [
    "35845",
    9,
    "9598",
    "76225",
    "20385",
    "47387",
    "3199",
    "88565",
    "50437",
    "27174",
    "63810",
    "26088",
    "24429",
    "45481",
    "6129",
    "41887",
    "8349"
  ],
  "./desktop/CoronaVirus": [
    "33931",
    9,
    "9598",
    "33580",
    "47387",
    "3199",
    "88565",
    "27174",
    "26088",
    "21475",
    "23842",
    "12481",
    "68519",
    "89318",
    "36979"
  ],
  "./desktop/CoronaVirus.js": [
    "33931",
    9,
    "9598",
    "33580",
    "47387",
    "3199",
    "88565",
    "27174",
    "26088",
    "21475",
    "23842",
    "12481",
    "68519",
    "89318",
    "36979"
  ],
  "./mobile": [
    "72096",
    9,
    "9598",
    "76225",
    "20385",
    "47387",
    "3199",
    "88565",
    "50437",
    "6937",
    "27174",
    "38154",
    "17189",
    "63810",
    "26088",
    "24429",
    "45481",
    "6129",
    "41887",
    "27085"
  ],
  "./mobile/CoronaVirus.scss": [
    "79905",
    7,
    "12622"
  ],
  "./desktop": [
    "94106",
    9,
    "9598",
    "76225",
    "62815",
    "33580",
    "47387",
    "3199",
    "88565",
    "50437",
    "27174",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "26088",
    "21475",
    "23842",
    "12481",
    "68519",
    "89318",
    "70171"
  ],
  "./desktop/": [
    "94106",
    9,
    "9598",
    "76225",
    "62815",
    "33580",
    "47387",
    "3199",
    "88565",
    "50437",
    "27174",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "26088",
    "21475",
    "23842",
    "12481",
    "68519",
    "89318",
    "70171"
  ],
  "./mobile/": [
    "72096",
    9,
    "9598",
    "76225",
    "20385",
    "47387",
    "3199",
    "88565",
    "50437",
    "6937",
    "27174",
    "38154",
    "17189",
    "63810",
    "26088",
    "24429",
    "45481",
    "6129",
    "41887",
    "27085"
  ],
  "./mobile/CoronaVirus": [
    "35845",
    9,
    "9598",
    "76225",
    "20385",
    "47387",
    "3199",
    "88565",
    "50437",
    "27174",
    "63810",
    "26088",
    "24429",
    "45481",
    "6129",
    "41887",
    "8349"
  ],
  "./mobile/index": [
    "72096",
    9,
    "9598",
    "76225",
    "20385",
    "47387",
    "3199",
    "88565",
    "50437",
    "6937",
    "27174",
    "38154",
    "17189",
    "63810",
    "26088",
    "24429",
    "45481",
    "6129",
    "41887",
    "27085"
  ],
  "./mobile/index.js": [
    "72096",
    9,
    "9598",
    "76225",
    "20385",
    "47387",
    "3199",
    "88565",
    "50437",
    "6937",
    "27174",
    "38154",
    "17189",
    "63810",
    "26088",
    "24429",
    "45481",
    "6129",
    "41887",
    "27085"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 45405;
module.exports = __rspack_async_context;
